<template>
  <div>
      <contact-nearest-tab v-if="TAB_NEAREST === ACTIVE_TAB"/>
      <contact-all-tab v-if="TAB_ALL === ACTIVE_TAB"/>
      <contact-search-tab v-if="TAB_SEARCH === ACTIVE_TAB"/>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ContactSearchTab from './SearchTab';
    import ContactNearestTab from './NearestTab';
    import ContactAllTab from './AllTab';
    import {ACTIVE_TAB} from './getter';
    import {NAMESPACE} from './store';
    import {TAB_NEAREST, TAB_SEARCH, TAB_ALL} from './constants';

    export default {
        name: 'ContactTabContent',
        data() {
            return {TAB_NEAREST, TAB_SEARCH, TAB_ALL}
        },
        components: {
            ContactAllTab,
            ContactNearestTab,
            ContactSearchTab
        },
        computed: {
            ...mapGetters(NAMESPACE, [ACTIVE_TAB]),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/TabContent.vue